import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@ui/badge.tsx';
import { cn } from '@r/utils/utils.ts';

interface ConfigurationStatusBadgeProps {
  isValid: boolean | undefined;
  // Configuration en cours de récupération chez Vercel et Brevo
  isLoading?: boolean;
}

export const ConfigurationStatusBadge = ({
  isValid,
  isLoading = false
}: ConfigurationStatusBadgeProps) => {
  const { t } = useTranslation();

  if (!isLoading && isValid === undefined) {
    return null;
  }

  return (
    <Badge
      variant="outline"
      className="gap-1.5 font-normal text-xs border-muted-foreground/20 w-fit shrink-0"
    >
      {isLoading ? (
        <>
          <Loader2 className="w-3 h-3 animate-spin text-muted-foreground" aria-hidden />
          {t('workspace.configuration.status.loading')}
        </>
      ) : (
        <>
          <span
            className={cn(
              'size-1.5 shrink-0 rounded-full',
              isValid ? 'bg-emerald-600' : 'bg-red-500'
            )}
            aria-hidden
          />
          {isValid
            ? t('workspace.configuration.status.authenticated')
            : t('workspace.configuration.status.not.authenticated')}
        </>
      )}
    </Badge>
  );
};
